import { RangeFilter } from '@admin/shared/models/range.model';

import { Serializable } from '@admin/core/models/serializable';
import { PermissionModel } from '@admin/shared/models/permission-model';

export class AdminUserFilterModel
  implements Serializable<AdminUserFilterModel>
{
  fromObject(obj: any): AdminUserFilterModel {
    throw new Error('Not Implemented');
  }
  toObject() {
    let result = {
      AdminId: this.adminId,
      Fullname: this.fullName,
      Email: this.email,
      Position: this.position,
      Username: this.username,
      DateAdded: this.dateAdded,
    };
    return result;
  }

  public adminId: number;
  public fullName: string;
  public email: string;
  public position: string;
  public username: string;
  public dateAdded: Date;

  consturctor() {
    this.adminId = null;
    this.fullName = null;
    this.email = null;
    this.position = null;
    this.username = null;
    this.dateAdded = null;
  }
}
